import { formatRelativeTimeLabel } from "../timestampFormat";

export function formatThreadTimeLabel(
  at: string,
  mode: "working" | "snoozed" | "settled",
  now: number,
): string {
  const timestamp = Date.parse(at);
  if (!Number.isFinite(timestamp)) return "";
  if (mode === "settled")
    return formatRelativeTimeLabel(at, now).replace(/ ago$/, "").replace("just now", "now");
  const seconds = Math.max(
    0,
    Math.floor((mode === "snoozed" ? timestamp - now : now - timestamp) / 1000),
  );
  if (mode === "snoozed")
    return seconds === 0
      ? "now"
      : seconds < 3600
        ? `${Math.ceil(seconds / 60)}m`
        : seconds < 86400
          ? `${Math.ceil(seconds / 3600)}h`
          : `${Math.ceil(seconds / 86400)}d`;
  return seconds < 60
    ? `${seconds}s`
    : seconds < 3600
      ? `${Math.floor(seconds / 60)}m`
      : `${Math.floor(seconds / 3600)}h ${Math.floor((seconds % 3600) / 60)}m`;
}
